import { Dropdown } from 'react-bootstrap'
import React from 'react'
import { TooltipPopOver } from '@ztechapps/webui.util'

type DropdownItemProps = {
  disabled: boolean
  name: string
  menuTarget: { show: string | null }
  title?: string
  children: React.ReactNode
}

export const DropdownItem = ({ disabled, name, menuTarget, title, children }: DropdownItemProps) => {
  return (
    <TooltipPopOver tooltipBody={title}>
      <Dropdown.Item id={name} disabled={disabled} eventKey={name} active={menuTarget?.show === name}>
        {children}
      </Dropdown.Item>
    </TooltipPopOver>
  )
}
